import AdminWebhooks from './container';

export default AdminWebhooks;
